(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sorbis-b2b-italia"] && !Shopify.designMode) return;
  try {
    

function initB2BI(){document.querySelectorAll('[data-b2bi]').forEach(root=>{if(root.dataset.bound)return;root.dataset.bound='true';const form=root.querySelector('form'),path=root.querySelector('#b2bi-path');root.querySelectorAll('[data-path]').forEach(link=>link.addEventListener('click',()=>{if(path)path.value=link.dataset.path;}));const date=root.querySelector('#b2bi-date');if(date){const d=new Date();date.min=[d.getFullYear(),String(d.getMonth()+1).padStart(2,'0'),String(d.getDate()).padStart(2,'0')].join('-');}if(form&&!root.querySelector('[data-b2bi-success]')){form.addEventListener('submit',()=>{const ref='B2BI-'+Date.now().toString(36);const input=root.querySelector('[data-b2bi-reference]');if(input)input.value=ref;try{sessionStorage.setItem('sorbis_b2bi_pending',ref);}catch(e){}});}const success=root.querySelector('[data-b2bi-success]');if(success){success.focus();try{const ref=sessionStorage.getItem('sorbis_b2bi_pending');if(ref){sessionStorage.removeItem('sorbis_b2bi_pending');if(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()&&window.Shopify?.analytics?.publish){window.Shopify.analytics.publish('sorbis_b2b_request_submitted',{form:'b2b_italia',submission_id:ref});}}}catch(e){}}});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initB2BI,{once:true});else initB2BI();document.addEventListener('shopify:section:load',initB2BI);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sorbis-cart-request"]) return;
  try {
    
  if (!customElements.get('sorbis-cart-request')) {
    class SorbisCartRequest extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const invalidate = () => {
          const submit = this.querySelector('[data-sorbis-checkout], .sorbis-cart-request__contact-form button[type="submit"]');
          if (submit) submit.disabled = true;
          const notice = this.querySelector('[data-request-update-notice]');
          if (notice) notice.hidden = false;
        };
        this.querySelectorAll('[data-request-quantity]').forEach(input => input.addEventListener('input', invalidate, options));
        this.querySelectorAll('[data-request-quantity-step]').forEach(button => {
          button.addEventListener('click', () => {
            const input = button.closest('.sorbis-cart-request__quantity-control')?.querySelector('[data-request-quantity]');
            if (!input) return;
            input.value = Math.max(Number(input.min || 1), Number(input.value || 0) + Number(button.dataset.requestQuantityStep) * Number(input.step || 1));
            input.dispatchEvent(new Event('input', { bubbles: true }));
          }, options);
        });
      }
      disconnectedCallback() { this.controller?.abort(); }
    }
    customElements.define('sorbis-cart-request', SorbisCartRequest);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sorbis-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sorbis-quantity-control')) {
    class SorbisQuantityControl extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-sorbis-quantity-step]').forEach((button) => {
          button.addEventListener('click', () => {
            const input = this.querySelector('.sorbis-product__quantity');
            if (!input) return;
            const minimum = Number(input.min || 1);
            const maximum = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;
            const next = Number(input.value || minimum) + Number(button.dataset.sorbisQuantityStep);
            input.value = Math.min(maximum, Math.max(minimum, next));
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
      }
    }
    customElements.define('sorbis-quantity-control', SorbisQuantityControl);
  }

  } catch(e) { console.error(e); }
})();
})();
